<template>
  <v-container fluid class="px-0 py-0 pt-3">
    <v-layout wrap>
      <v-flex xs12>
        <v-card class="elevation-1">
          <v-layout wrap align-center class="px-3 pt-2">
            <v-flex xs12 sm8 md9>
              <v-tabs v-model="tab" color="#005f32">
                <v-tab>Unread ({{ unreadNotifications.length }})</v-tab>
                <v-tab>Read ({{ readNotifications.length }})</v-tab>
              </v-tabs>
            </v-flex>
            <v-flex xs12 sm4 md3 class="text-right pb-2 pb-sm-0 px-3">
              <v-btn color="#005f32" outlined small @click="markAllAsRead" v-if="unreadNotifications.length > 0">
                Mark all as read
              </v-btn>
            </v-flex>
          </v-layout>
          <v-divider></v-divider>

          <v-tabs-items v-model="tab">
            <v-tab-item>
              <div v-if="unreadNotifications.length > 0">
                <v-list>
                  <v-list-item v-for="(n, i) in paginatedUnread" :key="i" @click="handleNotificationClick(n)" style="border-bottom: 1px solid #f0f0f0; cursor: pointer;" class="px-4 py-3">
                    <v-list-item-avatar v-if="n.title === 'Complete Profile Details' || n.title === 'Profile Incomplete'" color="transparent" size="45" class="mr-4">
                      <v-progress-circular
                        :rotate="-90"
                        :size="45"
                        :width="4"
                        :value="profileCompletionPercent"
                        color="#005f32"
                      >
                        <span style="font-size: 11px; font-weight: bold; color: #005f32;">{{ profileCompletionPercent }}%</span>
                      </v-progress-circular>
                    </v-list-item-avatar>
                    <v-list-item-avatar v-else color="rgba(0, 95, 50, 0.1)" size="45" class="mr-4">
                      <v-icon color="#005f32">mdi-bell-ring-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-left">
                      <v-list-item-title class="font-weight-bold mb-1" style="color: #2c3e50; font-size: 15px;">{{ n.title }}</v-list-item-title>
                      <v-list-item-subtitle style="white-space: normal; line-height: 1.4; color: #5a6c7d; font-size: 13.5px;">{{ n.body || n.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <v-icon color="grey lighten-1" small>mdi-chevron-right</v-icon>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <div class="text-center pt-2 pb-4">
                  <v-pagination v-model="unreadPage" :length="unreadPages" v-if="unreadPages > 1" color="#005f32" circle></v-pagination>
                </div>
              </div>
              <div v-else class="pa-5 text-center grey--text">
                No unread notifications
              </div>
            </v-tab-item>

            <v-tab-item>
              <div v-if="readNotifications.length > 0">
                <v-list>
                  <v-list-item v-for="(n, i) in paginatedRead" :key="i" @click="handleNotificationClick(n)" style="border-bottom: 1px solid #f0f0f0; cursor: pointer;" class="px-4 py-3">
                    <v-list-item-avatar v-if="n.title === 'Complete Profile Details' || n.title === 'Profile Incomplete'" color="transparent" size="45" class="mr-4">
                      <v-progress-circular
                        :rotate="-90"
                        :size="45"
                        :width="4"
                        :value="profileCompletionPercent"
                        color="grey darken-1"
                      >
                        <span style="font-size: 11px; font-weight: bold; color: grey;">{{ profileCompletionPercent }}%</span>
                      </v-progress-circular>
                    </v-list-item-avatar>
                    <v-list-item-avatar v-else color="grey lighten-4" size="45" class="mr-4">
                      <v-icon color="grey darken-1">mdi-bell-outline</v-icon>
                    </v-list-item-avatar>
                    <v-list-item-content class="text-left">
                      <v-list-item-title class="font-weight-medium mb-1" style="color: #555; font-size: 15px;">{{ n.title }}</v-list-item-title>
                      <v-list-item-subtitle style="white-space: normal; line-height: 1.4; color: #888; font-size: 13.5px;">{{ n.body || n.message }}</v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
                <div class="text-center pt-2 pb-4">
                  <v-pagination v-model="readPage" :length="readPages" v-if="readPages > 1" color="#005f32" circle></v-pagination>
                </div>
              </div>
              <div v-else class="pa-5 text-center grey--text">
                No read notifications
              </div>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      tab: 0,
      notifications: [],
      unreadPage: 1,
      readPage: 1,
      itemsPerPage: 10,
      profileCompletionPercent: 0
    };
  },
  computed: {
    unreadNotifications() {
      return this.notifications.filter(n => n.status === 'unread' || !n.status); 
    },
    readNotifications() {
      return this.notifications.filter(n => n.status === 'read');
    },
    paginatedUnread() {
      const start = (this.unreadPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.unreadNotifications.slice(start, end);
    },
    paginatedRead() {
      const start = (this.readPage - 1) * this.itemsPerPage;
      const end = start + this.itemsPerPage;
      return this.readNotifications.slice(start, end);
    },
    unreadPages() {
      return Math.ceil(this.unreadNotifications.length / this.itemsPerPage);
    },
    readPages() {
      return Math.ceil(this.readNotifications.length / this.itemsPerPage);
    }
  },
  methods: {
    async fetchNotifications() {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const notifRes = await axios.get('/notification/getlist', { headers: { 'x-auth-token': token } });
          if (notifRes.data && notifRes.data.status) {
            let apiNotifs = notifRes.data.data || [];
            let allNotifs = [];
            
            const position = localStorage.getItem("position");
            const isSuperAdmin = position === '62a2de91ecd959516cd3b0e6';

            if (!isSuperAdmin && this.$store.state.userData && this.$store.state.userData.status === 'Incomplete') {
              allNotifs.push({
                title: "Profile Incomplete",
                message: "Welcome! Please complete your profile section to proceed with all portal features.",
                route: "/my-profile",
                status: 'unread'
              });
            }
            
            if (isSuperAdmin) {
              apiNotifs = apiNotifs.filter(n => n.title !== 'Complete Profile Details' && n.title !== 'Profile Incomplete');
            }
            
            allNotifs = allNotifs.concat(apiNotifs.map(n => ({
              id: n._id || n.id,
              title: n.title,
              message: n.body,
              route: n.route,
              status: n.status
            })));
            
            this.notifications = allNotifs;
          }
        } catch(e) {
          console.error("Error fetching notifications:", e);
        }
      }
    },
    async fetchProfileCompletion() {
      const id = localStorage.getItem("userid");
      const token = localStorage.getItem("token");
      if (!id || !token) return;
      try {
        const response = await axios.get("/employee/document/view", {
          headers: { "x-auth-token": token },
          params: { id: id }
        });
        if (response.data.status) {
          const mydocs = response.data.data;
          const doc = mydocs.documentDetails || {};
          const emp = mydocs.employeeDetails || {};
          
          let requiredFields = [
            emp.name || emp.employeeName,
            doc.fathersName,
            doc.mothersName,
            emp.dob || emp.dateofbirth,
            doc.placeOfBirth,
            emp.gender,
            doc.bloodGroup,
            doc.nationality,
            emp.phonenumber || emp.phoneNumber || emp.mobileno || emp.mobile,
            emp.email || emp.emailid || emp.emailId || doc.personalEmail,
            doc.mailingAddress || emp.address,
            doc.mailingPin,
            doc.permanentAddress || emp.address,
            doc.permanentPin,
            doc.panCardNum,
            doc.adharCardNum,
            doc.bankName,
            doc.acNum,
            doc.ifsc,
            doc.epfUan,
            doc.maritalStatus,
            doc.emergencyContactName,
            doc.emergencyContactNo,
            doc.emergencyContactAddress,
            (doc.educationalQualifications && doc.educationalQualifications.length > 0) ? "filled" : "",
            (doc.employmentRecords && doc.employmentRecords.length > 0) ? "filled" : "",
            doc.publicationsPapers,
            doc.motherTongue,
            (doc.otherLanguages && doc.otherLanguages.length > 0) ? "filled" : "",
            doc.hobbies,
            doc.socialWork,
            doc.sportsParticipation,
            doc.specialInterests
          ];

          if (doc.maritalStatus === 'Married') {
            requiredFields.push(doc.dateOfMarriage);
            requiredFields.push(doc.spouseName);
            requiredFields.push(doc.spouseOccupation);
            requiredFields.push(doc.spouseOrganization);
          }
          
          let filled = 0;
          requiredFields.forEach(field => {
            if (field && String(field).trim() !== "" && String(field) !== "null" && String(field) !== "undefined") {
              filled++;
            }
          });
          
          this.profileCompletionPercent = Math.round((filled / requiredFields.length) * 100);

          if (this.profileCompletionPercent === 100) {
            this.notifications = this.notifications.filter(n => n.title !== 'Complete Profile Details' && n.title !== 'Profile Incomplete');
          }
        }
      } catch (e) {
        console.error("Failed to load profile for completion", e);
      }
    },
    async markAllAsRead() {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          await axios.get(`/notification/markallread`, { headers: { 'x-auth-token': token } });
          this.fetchNotifications();
          this.$root.$emit('notifications-read');
        } catch (e) {
          console.error("Error marking all notifications as read:", e);
        }
      }
    },
    async handleNotificationClick(n) {
      if (n.status === 'unread' && n.id) {
        try {
          const token = localStorage.getItem('token');
          await axios.get(`/notification/markasread?id=${n.id}`, { headers: { 'x-auth-token': token } });
          this.$root.$emit('notifications-read');
        } catch (e) {
          console.error("Error marking notification as read:", e);
        }
      }

      let r = n.route;
      if (r) {
        if (r === '/profile') {
          r = '/my-profile';
        } else if (r.startsWith('employee/leave/application/view/')) {
          const id = r.split('employee/leave/application/view/')[1];
          r = `/Attendance/leaveRequestsDetails?id=${id}`;
        } else if (r.startsWith('travelLog/view/')) {
          const id = r.split('travelLog/view/')[1];
          r = `/Attendance/travelRequestDetails?id=${id}`;
        } else if (!r.startsWith('/')) {
          r = '/' + r;
        }

        if (this.$route.fullPath !== r) {
          this.$router.push(r).catch(()=>{});
        }
      } else {
        this.fetchNotifications();
      }
    }
  },
  created() {
    this.fetchNotifications();
    this.fetchProfileCompletion();
  }
};
</script>
